import React from "react";
import { Link } from "react-router-dom";

const TopBanner: React.FC = () => {
  return (
    <a 
      href="https://dashboard.torqai.ca/" 
      className="top-banner"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="container">
        <div className="banner-content">
          <p className="desktop-banner-text d-none d-md-block">
            🚀 Stop missing calls today · Free 7-day trial · No credit card required
          </p>
          <p className="mobile-banner-text d-block d-md-none">
            🚀 Stop missing calls today <span style={{ textDecoration: 'underline', marginLeft: '8px' }}>READ MORE</span>
          </p>
        </div>
      </div>
    </a>
  );
};

export default TopBanner;
